// @flow
import TabElement from '@shared/Navigation/TabElement/components/TabElement';

export default TabElement;
